import { StepType, useTour } from '@reactour/tour';
import { useProvider } from 'utils/providers/Provider';
import { TOUR_SELECTOR } from 'ui/partials/Tour';
import { Button } from 'ui/components/common';

const useGetHowToManageEventSteps = () => {
  const { dispatch, state } = useProvider();
  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const isCollapsed = state?.collapse;

  const createEventSteps: StepType[] = [
    {
      content: 'Go to the Calendar menu tab',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.MENU}"]`,
      position: 'right',
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 200);
          },
          false,
        );
      },
      disableActions: true,
      styles: {
        arrow: (base) => ({
          ...base,
          visibility: 'hidden',
        }),
      },
    },
    {
      content: 'Then select Calendar to view the Calendar view page.',
      position: 'right',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.CALENDAR.SUBMENU}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(2), 200);
          },
          false,
        );
      },
      disableActions: false,
      styles: {
        arrow: (base) => ({
          ...base,
        }),
      },
    },
    {
      content: (props) => (
        <div {...props}>
          <p>Select a date on the calendar.</p>
          <div className="flex justify-end pt-5">
            <Button
              onClick={() => props.setCurrentStep(props.currentStep + 1)}
              label="NEXT"
            />
          </div>
        </div>
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.CALENDAR.MANAGE.DATE}"]`,
      position: 'right',
      stepInteraction: false,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(3), 200);
            // setIsOpen(false);
          },
          false,
        );
      },
    },
    {
      content: 'Then click on the event you want to manage.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.CALENDAR.MANAGE.DETAILS}"]`,
      disableActions: false,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(4), 300);
          },
          false,
        );
      },
      position: 'left',
    },
    {
      content: 'Click the three dots next to the event title.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.CALENDAR.MANAGE.MANAGE}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(5), 100);
          },
          false,
        );
      },
      position: 'top',
    },
    {
      content: 'Then select Edit.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.CALENDAR.MANAGE.EDIT_BUTTON}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(6), 100);
          },
          false,
        );
      },
      position: 'top',
    },
    {
      content: 'Edit the event details as necessary.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.CALENDAR.FORM.FORM}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(7), 100);
          },
          false,
        );
      },
      position: 'top',
    },
    {
      content: 'Click Save, and you are done.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CALENDAR.CALENDAR.FORM.SAVE_BUTTON}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setCurrentStep(0);
            setSteps?.([]);
          },
          false,
        );
      },
      position: 'top',
    },
  ];

  const showManageEventSteps = () => {
    if (isCollapsed) {
      dispatch?.({ type: 'toggleSidebar' });
    }

    setTimeout(() => {
      setSteps?.(createEventSteps);
      setIsOpen(true);
    }, 300);
  };

  return showManageEventSteps;
};

export default useGetHowToManageEventSteps;
